import React from "react";
import { IconButton } from "../core/IconButton.jsx";

export function Dialog({ title, description, children, footer, width = 404, onClose, style = {} }) {
  return (
    <div style={{ width, background: "var(--bg-pop)", border: "1px solid var(--line-b)", borderRadius: "var(--r-dialog)", boxShadow: "var(--shadow-dialog)", padding: "24px 26px", ...style }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <span style={{ fontSize: "var(--fs-15)", fontWeight: "var(--fw-semibold)", color: "var(--fg-1)" }}>{title}</span>
          {description ? <span style={{ fontSize: "var(--fs-12)", lineHeight: "var(--lh-normal)", color: "var(--fg-7)", textWrap: "pretty" }}>{description}</span> : null}
        </div>
        {onClose ? <IconButton icon="x" tip="Schließen" size="sm" onClick={onClose} /> : null}
      </div>
      {children ? <div style={{ paddingTop: 18 }}>{children}</div> : null}
      {footer ? <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, paddingTop: 16 }}>{footer}</div> : null}
    </div>
  );
}
